import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AproximationNumberService {
    constructor() {
    }

    public aproxToFormat(value: string, numDecimales: any): string {
        if (value !== undefined && value !== '-') {
            value = parseFloat(value).toLocaleString('en-GB', { minimumFractionDigits: numDecimales, maximumFractionDigits: numDecimales });
        } else {
            value = ' ';
        }
        return value;
    }

    public aproxToFormatNumber(value: number, numDecimales: any): number {
        return value !== undefined && value !== 0
            ? Number(value.toLocaleString('en-GB', {
                minimumFractionDigits: numDecimales,
                maximumFractionDigits: numDecimales
            }))
            : 0;
    }

    public redondeo(numero, decimales) {
        const resultado = parseFloat(parseFloat(numero).toFixed(decimales));
        return resultado;
    }

    public aproxNumber(value: any, numeroDecimales) {
        if (!numeroDecimales) {
            numeroDecimales = 3;
        }
        // devuelve el número pero en cadena
        value = parseFloat(value).toFixed(numeroDecimales);
        return parseFloat(value);
    }

    public reconvertFormatToNumber(value: string) {
        // primer paso: fuera puntos
        value = value.replace(/[,]/g, '');
        return parseFloat(value);
    }

    public convertDateFormat(value: string) {
        const fecha = value.split('-').reverse().join('/');
        return fecha;
    }

    public changeFecha(value: string) {
        const year = value.substr(0, 4);
        const month = value.substr(3, 2);
        const day = value.substr(5, 2);

        return day + '/' + month + '/' + year;
    }

    public formatNumber(num, numeroDecimales) {
        if (!numeroDecimales) {
            numeroDecimales = 3;
        }
        num = this.reconvertFormatToNumber(num);
        return new Intl.NumberFormat('es-Pe', {
            minimumFractionDigits: numeroDecimales
        }).format(num);
    }
}
